import React, { useEffect, useState } from "react";
import TextsmsIcon from "@mui/icons-material/Textsms";
import "./Header.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ImageChecker } from "./ImageChecker";
import NotificationPanel from "./NotificationPanel/NotificationPanel";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const Domain = "https://estbn.com/EstbnNew/public";
  const path = location.pathname.split("/").filter(Boolean);

  const { user } = useSelector((state) => state.auth);

  const [data, setData] = useState(null);

  useEffect(() => {
    if (user) {
      setData(user.operator || user.stuff || null);
    }
  }, [user]);

  return (
    <>
      <div className="pageHeader border-bottom">
        <div className="title m-left-20">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-header">
              <li
                onClick={() => navigate("/")}
                className="breadcrumb-item cursor"
              >
                Home
              </li>
              {path.map((e, i) => {
                const subPath = "/" + path.slice(0, i + 1).join("/");
                const formatted = decodeURIComponent(e.replace(/-/g, " "));
                return (
                  <li
                    key={i}
                    className={`breadcrumb-item cursor ${
                      i === path.length - 1 ? "active" : ""
                    }`}
                    onClick={() => navigate(subPath)}
                  >
                    {formatted}
                  </li>
                );
              })}
            </ol>
          </nav>
        </div>

        <div className="headerInfo">
          <div className="userHeaderIcon">
            <TextsmsIcon />
          </div>

          <NotificationPanel />

          <div className="userImag">
            <ImageChecker
              profilePhoto={
                data?.profile_photo_path
                  ? `${Domain}${data.profile_photo_path}`
                  : null
              }
            />
          </div>
          <div className="userInfo">
            <div className="userInfo-username">{data?.username}</div>
            <div className="userInfo-userRow">{data?.roles?.[0]?.name}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
